import React from 'react';
import { useTranslation } from 'react-i18next';
import { parse } from 'query-string';
import { useLocation } from 'react-router-dom';

import { DeliveryLogType, StatusMessageCategory } from '@dev/ee-api/ee-api-models';

import { useDateDropdownValue } from '@/services/hooks/useDateDropdownValue';
import { ACTIVITY_TIME_RANGES } from '@/services/constants';
import { useEventsFilterOptions } from '../../../assets/EventFilter/useEventsFilterOptions';
import { useDateDropdownOptions } from './useDateDropdownOptions';
import { useMinMaxDate } from './useMinMaxDate';

enum MobileFilterTabsTypes {
    DATE = 'date',
    EVENT = 'event',
}

export const useMobileFilterTabs = (
    timeRangeRef: React.MutableRefObject<number | string>,
    selected: (DeliveryLogType | StatusMessageCategory)[],
    lastEvent: boolean
): any => {
    const dateOptions = useDateDropdownOptions();
    const eventOptions = useEventsFilterOptions();
    const [minDate, maxDate] = useMinMaxDate();
    const { t } = useTranslation();
    const selectedEvents = lastEvent ? [] : [...(selected || [])];
    const location = useLocation();
    const query = parse(location.search);
    const startDate = query?.from?.toString();
    const endDate = query?.to?.toString();
    const dateRangeValue = useDateDropdownValue(true, null, ACTIVITY_TIME_RANGES);

    return [
        {
            id: MobileFilterTabsTypes.DATE,
            label: t('daterange') as string,
            defaultValue: dateRangeValue,
            options: dateOptions,
            type: 'date' as any,
            minDate,
            maxDate,
            startDate,
            endDate,
        },
        {
            id: MobileFilterTabsTypes.EVENT,
            defaultCheckboxValue: selectedEvents,
            label: t('event') as string,
            options: eventOptions,
            type: 'checkbox' as any,
        },
    ];
};
